// Digital Signing — Portal integration
// Shows signing status and "Sign Document" button on portal order detail pages.
// The actual signing ceremony happens on /signing-ceremony/<session>.

(function () {
	const path = window.location.pathname;
	if (!path.startsWith("/orders/") && path !== "/signing-certificates") return;

	if (window.frappe && frappe.boot && frappe.boot.setup_wizard_requires) return;

	document.addEventListener("DOMContentLoaded", function () {
		handle_signing_result();

		if (path === "/signing-certificates") {
			setup_certificate_page();
			return;
		}

		const match = path.match(/^\/orders\/(.+)/);
		if (!match) return;

		const docname = decodeURIComponent(match[1]);
		const doctype = "Sales Order";

		fetch(
			`/api/method/digital_signing.api.envelope.get_envelope_for_doc?doctype=${encodeURIComponent(doctype)}&docname=${encodeURIComponent(docname)}`,
			{ headers: { "X-Frappe-CSRF-Token": frappe.csrf_token } }
		)
			.then((r) => r.json())
			.then((r) => {
				if (!r.message) return;
				inject_signing_ui(r.message, doctype, docname);
			})
			.catch((err) => console.error("Digital Signing portal error:", err));
	});

	function handle_signing_result() {
		const params = new URLSearchParams(window.location.search);
		if (params.get("signing_complete")) {
			show_toast("Document signed successfully", "green");
			history.replaceState(null, "", window.location.pathname);
		}
		if (params.get("signing_error")) {
			show_toast(decodeURIComponent(params.get("signing_error")), "red");
			history.replaceState(null, "", window.location.pathname);
		}
	}

	function show_toast(message, color) {
		const toast = document.createElement("div");
		toast.className = `alert alert-${color === "green" ? "success" : "danger"} mt-3`;
		toast.style.cssText =
			"position:fixed;top:20px;right:20px;z-index:9999;max-width:400px;";
		toast.textContent = message;
		document.body.appendChild(toast);
		setTimeout(() => toast.remove(), 5000);
	}

	function inject_signing_ui(info, doctype, docname) {
		const pageContent =
			document.querySelector(".main-column") ||
			document.querySelector(".page-content-block") ||
			document.querySelector("main .container") ||
			document.querySelector("main");
		if (!pageContent) return;

		const wrapper = document.createElement("div");
		wrapper.className = "digital-signing-portal mt-4 mb-4";

		const status = info.status;
		const signers = info.signers || [];
		const signedCount = signers.filter((s) => s.status === "Signed").length;

		if (status === "Signed" || status === "Partially Signed") {
			const pillClass = status === "Signed" ? "green" : "blue";
			const alertClass = status === "Signed" ? "success" : "info";
			const summary =
				status === "Signed"
					? `Fully signed (${signers.length} signer${signers.length === 1 ? "" : "s"})`
					: `${signedCount} of ${signers.length} signed — awaiting next signer`;

			wrapper.innerHTML = `
				<div class="alert alert-${alertClass} d-flex align-items-center" role="alert">
					<span class="indicator-pill ${pillClass} mr-2">${status}</span>
					<span>${summary}</span>
					${info.pdf_file ? `<a href="${info.pdf_file}" class="btn btn-sm btn-outline-${alertClass} ml-auto" target="_blank">Download ${status === "Signed" ? "Signed" : "Latest"} PDF</a>` : ""}
				</div>
			`;
			pageContent.appendChild(wrapper);
			if (status === "Signed" || !info.can_sign) return;
		}

		if (!info.can_sign) return;

		const signWrapper = document.createElement("div");
		signWrapper.className = "digital-signing-portal mt-2 mb-4";
		signWrapper.innerHTML = `
			<div class="alert alert-warning d-flex align-items-center" role="alert">
				<span class="indicator-pill orange mr-2">Action Required</span>
				<span>This document requires your digital signature${info.my_role ? ` as ${info.my_role}` : ""}.</span>
				<button class="btn btn-sm btn-primary ml-auto" id="portal-sign-btn">Sign Document</button>
			</div>
			<div id="signing-error" class="alert alert-danger d-none mt-2"></div>
		`;
		pageContent.appendChild(signWrapper);

		document.getElementById("portal-sign-btn").addEventListener("click", function () {
			const btn = this;
			btn.disabled = true;
			btn.textContent = "Starting...";

			const errorDiv = document.getElementById("signing-error");
			errorDiv.classList.add("d-none");

			fetch("/api/method/digital_signing.api.envelope.sign_doc", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-Frappe-CSRF-Token": frappe.csrf_token,
				},
				body: JSON.stringify({ doctype, docname }),
			})
				.then((r) => r.json())
				.then((r) => {
					if (r.message && r.message.ceremony_url) {
						window.location.href = r.message.ceremony_url;
					} else if (r.exc) {
						let errMsg = "Failed to start signing";
						try { errMsg = JSON.parse(r.exc)[0] || errMsg; } catch (e) {}
						errorDiv.textContent = errMsg;
						errorDiv.classList.remove("d-none");
						btn.disabled = false;
						btn.textContent = "Sign Document";
					}
				})
				.catch(() => {
					errorDiv.textContent = "Failed to start signing. Please try again.";
					errorDiv.classList.remove("d-none");
					btn.disabled = false;
					btn.textContent = "Sign Document";
				});
		});
	}

	function setup_certificate_page() {
		const container =
			document.querySelector(".page-content") ||
			document.querySelector(".web-list") ||
			document.querySelector("main");
		if (!container) return;

		fetch("/api/method/digital_signing.api.signing.get_my_certificate_status", {
			headers: { "X-Frappe-CSRF-Token": frappe.csrf_token },
		})
			.then((r) => r.json())
			.then((r) => {
				if (r.message && r.message.has_active) return;
				const wrapper = document.createElement("div");
				wrapper.className = "mb-4";
				wrapper.innerHTML = `
					<div class="alert alert-warning d-flex align-items-center" role="alert">
						<span>You don't have an active signing certificate. You need one to sign documents.</span>
						<a href="/certificate-request/new" class="btn btn-sm btn-primary ml-auto">Request Certificate</a>
					</div>
				`;
				container.prepend(wrapper);
			})
			.catch(() => {});
	}

})();
